import { useRef } from 'react'
import { Drawer as BaseDrawer } from '@base-ui/react/drawer'
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.styles'
import type { OverlayProps } from '../ResponsiveSheet/overlay.types'
import { useOverlayUnmountFailsafe } from '../ResponsiveSheet/useOverlayUnmountFailsafe'
import { useBlurActiveElementOnOpen } from 'utils/mui-utils'
import * as S from './Drawer.styles'

// Mobile bottom drawer built on Base UI's Drawer (vaul's successor, same
// swipe-to-dismiss). Shares Base UI's Dialog foundation with the desktop
// Sheet, so nested MUI dialogs stay interactive. Composition follows
// shadcn/ui's Base UI drawer
function Drawer({
  open,
  onOpenChange,
  title,
  header,
  footer,
  contentTestId,
  heightMode = 'default',
  className,
  children,
}: OverlayProps) {
  const actionsRef = useRef<BaseDrawer.Root.Actions>(null)
  useBlurActiveElementOnOpen(open)
  useOverlayUnmountFailsafe(open, actionsRef)

  return (
    <BaseDrawer.Root
      open={open}
      onOpenChange={onOpenChange}
      actionsRef={actionsRef}
    >
      <BaseDrawer.Portal>
        <S.Backdrop />
        <S.Viewport>
          <S.Popup $tall={heightMode === 'tall'} data-testid={contentTestId}>
            <S.Content>
              <VisuallyHidden as={BaseDrawer.Title}>{title}</VisuallyHidden>
              {header}
              <S.Body className={className}>{children}</S.Body>
              {footer}
            </S.Content>
          </S.Popup>
        </S.Viewport>
      </BaseDrawer.Portal>
    </BaseDrawer.Root>
  )
}

export default Drawer
